"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SeparateNumericsDateInput = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputWrapper = require("./InputWrapper");
var _utils = require("./lib/utils");
var _constants = require("./lib/constants");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A date input component that is comprised of separate text inputs that auto-tab as the
 * user fills them out. Provides internal date validation and passes an object in the
 * callback function with shape:
 * {
 *    date: a valid Date object or null
 *    month: the string value of the month input
 *    day: the string value of the day input
 *    year: the string value of the year input
 *    errors: an Array of error Strings that result from failed internal validation
 * }
 *
 * @param {String} label The legend text for the fieldset
 * @param {Boolean} hideLabel Whether or not the legend for the fieldset should display to sighted users
 * @param {Boolean} required Whether or not the input is required
 * @param {Object} month The config object used to construct the month input
 * @param {Object} day The config object used to construct the day input
 * @param {Object} year The config object used to construct the year input
 * @param {Array} errors Errors from the consumer
 * @param {Function} onChange The callback function to notify the consumer of changes
 */
const SeparateNumericsDateInput = _ref => {
  let {
    disabled = false,
    label,
    hideLabel,
    required,
    month,
    day,
    year,
    errors = [],
    onChange
  } = _ref;
  // prevent useEffect hooks below from calling onChange
  // on initial render
  const isInitialized = (0, _react.useRef)({
    month: false,
    day: false,
    year: false
  });
  const [monthState, setMonthState] = (0, _react.useState)((0, _utils.getInitialState)(month, _constants.INPUT_TYPE_MONTH));
  const [dayState, setDayState] = (0, _react.useState)((0, _utils.getInitialState)(day, _constants.INPUT_TYPE_DAY));
  const [yearState, setYearState] = (0, _react.useState)((0, _utils.getInitialState)(year, _constants.INPUT_TYPE_YEAR));
  const monthInputRef = (0, _react.useRef)();
  const dayInputRef = (0, _react.useRef)();
  const yearInputRef = (0, _react.useRef)();

  /**
   * This will only run once all the inputs have been given values,
   * which is our best indication that the user has finished filling out
   * all the inputs
   */
  const validateDateAndUpdateParent = () => {
    const dateObject = (0, _utils.getValidDate)(monthState.value, dayState.value, yearState.value);
    onChange((0, _utils.buildDateResponseObject)(dateObject, monthState, dayState, yearState));
  };

  /**
   * These will fire when the children's state get updated.
   * Auto-tabs to the next input when appropriate (only auto-tab on onChange,
   * not onBlur), then validates and calls the onChange callback function when appropriate.
   */
  (0, _react.useEffect)(() => {
    if (monthState.lastEventType === _constants.EVENT_TYPE_CHANGE && monthState.value.length === 2) {
      dayInputRef.current.focus();
    }
    isInitialized.current.month && validateDateAndUpdateParent();
    isInitialized.current.month = true;
  }, [monthState]);
  (0, _react.useEffect)(() => {
    if (dayState.lastEventType === _constants.EVENT_TYPE_CHANGE && dayState.value.length === 2) {
      yearInputRef.current.focus();
    }
    isInitialized.current.day && validateDateAndUpdateParent();
    isInitialized.current.day = true;
  }, [dayState]);
  (0, _react.useEffect)(() => {
    isInitialized.current.year && validateDateAndUpdateParent();
    isInitialized.current.year = true;
  }, [yearState]);
  let parentErrors = (0, _map.default)(errors).call(errors, error => {
    return /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
      key: error
    }, error);
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.StyledFieldset, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledLegend, {
    visible: !hideLabel
  }, label), /*#__PURE__*/_react.default.createElement(_styles.StyledDateInputsContainer, null, /*#__PURE__*/_react.default.createElement(_InputWrapper.InputWrapper, {
    config: month,
    inputType: _constants.INPUT_TYPE_MONTH,
    parentErrors: errors,
    ref: monthInputRef,
    required: required,
    setState: setMonthState,
    state: monthState
  }), /*#__PURE__*/_react.default.createElement(_InputWrapper.InputWrapper, {
    config: day,
    inputType: _constants.INPUT_TYPE_DAY,
    parentErrors: errors,
    ref: dayInputRef,
    required: required,
    setState: setDayState,
    state: dayState
  }), /*#__PURE__*/_react.default.createElement(_InputWrapper.InputWrapper, {
    config: year,
    inputType: _constants.INPUT_TYPE_YEAR,
    parentErrors: errors,
    ref: yearInputRef,
    required: required,
    setState: setYearState,
    state: yearState
  })), /*#__PURE__*/_react.default.createElement(_styles.StyledErrorContainer, null, monthState.isErrorVisible && monthState.error && /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, null, monthState.error), dayState.isErrorVisible && dayState.error && /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, null, dayState.error), yearState.isErrorVisible && yearState.error && /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, null, yearState.error), parentErrors && parentErrors)));
};
exports.SeparateNumericsDateInput = SeparateNumericsDateInput;
SeparateNumericsDateInput.propTypes = {
  /**
   * The legend text for the fieldset
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Whether or not the legend for the fieldset should display to sighted users
   */
  hideLabel: _propTypes.default.bool,
  /**
   * Whether or not the input is required
   */
  required: _propTypes.default.bool,
  /**
   * The config object used to construct the month input
   */
  month: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    initialValue: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    ariaDescription: _propTypes.default.string.isRequired,
    invalidMsg: _propTypes.default.string.isRequired,
    isRequiredMsg: _propTypes.default.string.isRequired
  }).isRequired,
  /**
   * The config object used to construct the day input
   */
  day: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    initialValue: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    ariaDescription: _propTypes.default.string.isRequired,
    invalidMsg: _propTypes.default.string.isRequired,
    isRequiredMsg: _propTypes.default.string.isRequired
  }).isRequired,
  /**
   * The config object used to construct the year input
   */
  year: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    initialValue: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    ariaDescription: _propTypes.default.string.isRequired,
    invalidMsg: _propTypes.default.string.isRequired,
    isRequiredMsg: _propTypes.default.string.isRequired
  }).isRequired,
  /**
   * The error message passed in from the consumer. If this is present, the date input is considered to be in an
   * error state and the individual inputs will render in their error states. Pass this in when validation fails
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * The callback function that will be called when the inputs have been filled out by the user. There is internal
   * logic that determines when it is appropriate to call this function (e.g. once the user has entered a value for
   * each individual input). Passes an object parameter with shape: {month:'string', day:'string', year: 'string'}
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Allows for disabling all inputs.
   */
  disabled: _propTypes.default.bool
};
SeparateNumericsDateInput.defaultProps = {
  errors: [],
  disabled: false
};
SeparateNumericsDateInput.__docgenInfo = {
  "description": "A date input component that is comprised of separate text inputs that auto-tab as the\nuser fills them out. Provides internal date validation and passes an object in the\ncallback function with shape:\n{\n   date: a valid Date object or null\n   month: the string value of the month input\n   day: the string value of the day input\n   year: the string value of the year input\n   errors: an Array of error Strings that result from failed internal validation\n}\n\n@param {String} label The legend text for the fieldset\n@param {Boolean} hideLabel Whether or not the legend for the fieldset should display to sighted users\n@param {Boolean} required Whether or not the input is required\n@param {Object} month The config object used to construct the month input\n@param {Object} day The config object used to construct the day input\n@param {Object} year The config object used to construct the year input\n@param {Array} errors Errors from the consumer\n@param {Function} onChange The callback function to notify the consumer of changes",
  "methods": [],
  "displayName": "SeparateNumericsDateInput",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Allows for disabling all inputs.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The error message passed in from the consumer. If this is present, the date input is considered to be in an\nerror state and the individual inputs will render in their error states. Pass this in when validation fails",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "label": {
      "description": "The legend text for the fieldset",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "hideLabel": {
      "description": "Whether or not the legend for the fieldset should display to sighted users",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "required": {
      "description": "Whether or not the input is required",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "month": {
      "description": "The config object used to construct the month input",
      "type": {
        "name": "shape",
        "value": {
          "label": {
            "name": "string",
            "required": true
          },
          "name": {
            "name": "string",
            "required": true
          },
          "initialValue": {
            "name": "string",
            "required": false
          },
          "placeholder": {
            "name": "string",
            "required": false
          },
          "autoComplete": {
            "name": "string",
            "required": false
          },
          "ariaDescription": {
            "name": "string",
            "required": true
          },
          "invalidMsg": {
            "name": "string",
            "required": true
          },
          "isRequiredMsg": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    },
    "day": {
      "description": "The config object used to construct the day input",
      "type": {
        "name": "shape",
        "value": {
          "label": {
            "name": "string",
            "required": true
          },
          "name": {
            "name": "string",
            "required": true
          },
          "initialValue": {
            "name": "string",
            "required": false
          },
          "placeholder": {
            "name": "string",
            "required": false
          },
          "autoComplete": {
            "name": "string",
            "required": false
          },
          "ariaDescription": {
            "name": "string",
            "required": true
          },
          "invalidMsg": {
            "name": "string",
            "required": true
          },
          "isRequiredMsg": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    },
    "year": {
      "description": "The config object used to construct the year input",
      "type": {
        "name": "shape",
        "value": {
          "label": {
            "name": "string",
            "required": true
          },
          "name": {
            "name": "string",
            "required": true
          },
          "initialValue": {
            "name": "string",
            "required": false
          },
          "placeholder": {
            "name": "string",
            "required": false
          },
          "autoComplete": {
            "name": "string",
            "required": false
          },
          "ariaDescription": {
            "name": "string",
            "required": true
          },
          "invalidMsg": {
            "name": "string",
            "required": true
          },
          "isRequiredMsg": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    },
    "onChange": {
      "description": "The callback function that will be called when the inputs have been filled out by the user. There is internal\nlogic that determines when it is appropriate to call this function (e.g. once the user has entered a value for\neach individual input). Passes an object parameter with shape: {month:'string', day:'string', year: 'string'}",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};